import React from 'react'
import { useSelector } from 'react-redux'

const Details = ({ data }) => {
  const { step, color, material, materialSelected, addons, addons2, addonSeleted, addon2Seleted } = useSelector((state) => state.byo)
  let total = 0
  const stepData = () => {
    const productOption = step === 1 ? data.metafields.color[color] : (step === 2 ? data.metafields.material[materialSelected] : null)
    description = productOption ? productOption.description : null
    ctaTitle = productOption ? productOption.detail_cta_title : null
    tags = productOption ? productOption.tags : null
    popupMedia = productOption ? productOption.popup_media : null
    popupDescription = productOption ? productOption.popup_description : null
    return { productOption, displayTitle, description, ctaTitle, tags, popupMedia, popupDescription }

  }

  let { productOption, displayTitle, description, ctaTitle, tags, popupMedia, popupDescription } = stepData()

  let activeProduct = null
  let secondStepPrice = parseFloat(data.metafields.material[material].list_price)
  let basePrice = parseFloat(data.metafields.color[color].list_price)
  let activeVariant = null
  let variantIndex = data.metafields.material.length * color + material
  const dataAddons = step == 3 ? data.addons : data.addons2 
  switch (step) {
    case 1:
      total = basePrice
      displayTitle = data.metafields.color[color].detail_title
      break;
    case 2:
      total = secondStepPrice
        displayTitle = productOption.detail_title
      if (variantIndex < data.variants.length) total = data.variants[variantIndex].data.price / 100.0
      break;
    case 3:
      total = parseFloat(data.metafields.material[material].list_price)
      if (variantIndex < data.variants.length) total = data.variants[variantIndex].data.price / 100.0
      if (dataAddons && Array.isArray(dataAddons)) {
        dataAddons.map((addon) => {
          if (addon && addon.variants && Array.isArray(addon.variants)) {
            addon.variants.map((variant) => {
              if (
                addons.filter((a) => a.productId === addon.product.id && a.variantId === variant.data.id).length
              ) {
                total += variant.data.price / 100.0;
              }
            });
          }
        });
      }
      if (!addons || addons.length < 2 || !addonSeleted) {
        activeProduct = addonSeleted
          ? dataAddons.find((addon) => addon.product.id === addonSeleted.productId) || null
          : dataAddons[0];
      } else {
        activeProduct = (dataAddons && Array.isArray(dataAddons) && dataAddons.length > 0)
          ? dataAddons.filter((addon) => addons.some((selectedAddon) => selectedAddon.productId === addon.product.id))
          : null;
      }
      activeVariant = addons
        ? (activeProduct && Array.isArray(activeProduct) && activeProduct.length > 0)
          ? activeProduct
            .map((product) =>
              product.variants.filter((variant) =>
                addons.some((selectedAddon) => selectedAddon.variantId === variant.data.id)
              )
            )
            .flat()
          : null
        : (dataAddons &&
          Array.isArray(dataAddons) &&
          dataAddons.length > 0 &&
          dataAddons[0].variants &&
          Array.isArray(dataAddons[0].variants))
          ? dataAddons[0].variants.filter((variant) => variant.metafields.addon === true)
          : null;

      displayTitle = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.detail_title ? product.metafields.detail_title : product.product.title
        );
      description = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.short_description ? product.metafields.short_description : null
        );

      ctaTitle = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.cta_title ? product.metafields.cta_title : null
        );

      popupMedia = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.popup_media ? product.metafields.popup_media : null
        );

      popupDescription = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.popup_description ? product.metafields.popup_description : null
        );

      tags = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.tags ? product.metafields.tags : null
        );
      break;
    case 4:
      total = parseFloat(data.metafields.color[color].list_price) + parseFloat(data.metafields.material[material].list_price)
      if (variantIndex < data.variants.length) total = data.variants[variantIndex].data.price / 100.0
      if (data.addons && Array.isArray(data.addons)) {
        data.addons.map((addon) => {
          addon.variants.map((variant) => {
            if (addons.filter((a) => a.productId === addon.product.id && a.variantId === variant.data.id).length) {
              total += variant.data.price / 100.0;
            }
          });
        });
      }
      data.addons2.map((addon) => {
        addon.variants.map((variant) => {
          if (addons.filter((a) => a.productId === addon.product.id && a.variantId === variant.data.id).length) total += variant.data.price / 100.0
        })
      })
      if (!addons2 || addons2.length === 0) {
        activeProduct = addon2Seleted
          ? dataAddons.find((addon) => addon.product.id === addon2Seleted.productId) || null
          : dataAddons[0];
      } else {
        activeProduct = (dataAddons && Array.isArray(dataAddons) && dataAddons.length > 0)
          ? dataAddons.filter((addon) => addons.some((selectedAddon) => selectedAddon.productId === addon.product.id))
          : null;
      }


      activeVariant = addons
        ? (activeProduct && Array.isArray(activeProduct) && activeProduct.length > 0)
          ? activeProduct
            .map((product) =>
              product.variants.filter((variant) =>
                addons.some((selectedAddon) => selectedAddon.variantId === variant.data.id)
              )
            )
            .flat()
          : null
        : (dataAddons &&
          Array.isArray(dataAddons) &&
          dataAddons.length > 0 &&
          dataAddons[0].variants &&
          Array.isArray(dataAddons[0].variants))
          ? dataAddons[0].variants.filter((variant) => variant.metafields.addon === true)
          : null;

      displayTitle = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.detail_title ? product.metafields.detail_title : product.product.title
        );

      description = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.short_description ? product.metafields.short_description : null
        );

      ctaTitle = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.cta_title ? product.metafields.cta_title : null
        );

      popupMedia = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.popup_media ? product.metafields.popup_media : null
        );

      popupDescription = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.popup_description ? product.metafields.popup_description : null
        );

      tags = activeProduct && (Array.isArray(activeProduct) ? activeProduct : [activeProduct])
        .map((product) =>
          product.metafields && product.metafields.tags ? product.metafields.tags : null
        );
      break;
    default:
      break;
  }

  const addonLineItem = (step, addon, index) => {
    let dataAddons = step == 3 ? data.addons : data.addons2
    const product = dataAddons && Array.isArray(dataAddons) ? dataAddons.filter((a) => a.product && a.product.id === addon.productId).length > 0 ? dataAddons.filter((a) => a.product && a.product.id === addon.productId)[0] : null : null;
    if (product) {
      const variant = product.variants.filter((variant) => variant.data.id === addon.variantId)[0]
      if (typeof variant != 'undefined' && variant) {
        const variantImage = variant.data.featured_image ? variant.data.featured_image.src : (product.product.featured_image ? product.product.featured_image : null)
        return <div className='flex items-center justify-between border-b border-black py-2' key={`${step}-addon-${index}`}>
          <span className='font-bold inline-flex items-center text-xs'>
            {variantImage && <img className='w-10 mr-1' src={variantImage} />}
            {variant.data.name}
          </span>
          <span className='font-mono text-[0.75rem] leading-6 text-black'>${(variant.data.price / 100.0).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.00', '')}</span>
        </div>
      }
    }
  }

  const modalHtml = () => {
    return <div className='flex flex-col lg:grid grid-cols-5 gap-x-9 lg:h-[222px]'>
      {
        popupMedia &&
        (popupMedia.media_type == 'video' ?
          <div className='relative h-0 col-span-2' style={{ backgroundColor: '#FFF', background: 'FFF', paddingBottom: `${1 / popupMedia.aspect_ratio * 100}%` }}>
            <video className='!w-full !h-full lg:!h-[222px] lg:object-cover bg-white absolute top-0 left-0' width="120" autoPlay muted playsInline preload="metadata" height="140" controls>
              {
                popupMedia.sources.map((source, index) =>
                  <source src={source.url} type={source.mime_type} key={`popup-media-${index}`} />
                )
              }
              Your browser does not support the video tag.
            </video>
          </div> :
          <img className='col-span-2' src={typeof popupMedia.preview_image != 'undefined' ? popupMedia.preview_image.src : popupMedia} alt={popupMedia.alt} />
        )
      }
      <div className={`${popupMedia ? 'col-span-3' : 'col-span-5'}`}>
        {displayTitle && <div className='mb-4 text-base font-medium lg:text-20 text-puffco-light-black-3'>{displayTitle}</div>}
        {popupDescription && <div className='mb-4 text-xs' dangerouslySetInnerHTML={{ __html: popupDescription }}></div>}
      </div>
    </div>
  }
  const openModal = () => {
    openPuffcoModal(document.querySelector('#byoModalContent').innerHTML)
  }

  return (
    <div className='lg:w-2/5 bg-puffco-grey-5 pt-[3.75rem] lg:pt-[6.75rem] pb-12 px-4 h-full hidden lg:flex flex-col justify-between'>
      <div>
        {Array.isArray(displayTitle) && displayTitle.length > 0 && displayTitle.map((title, index) => (
          <div
            key={`addon-${index}`}
            className={`pb-6 mb-2 mt-1 lg:pt-[50px] ${productOption && productOption.value_props_title ? 'border-b border-black' : ''}`}
          >
            <h2 className='mb-3 lg:mb-6 text-base lg:text-20 font-semibold text-puffco-light-black-3'>{title}</h2>
            {
              description && description[index] ? <div className='text-xs mb-3 lg:w-[90%]'>{description[index]}</div> : null
            }
            {
              ctaTitle && ctaTitle[index] ?
                <button className={`text-xs text-black inline-flex items-center justify-between after:content-[''] after:w-1.5 after:h-1.5 after:border-black after:border-l-2 after:border-t-2 after:inline-block after:ml-2 after:transform after:rotate-[135deg] hover:underline`} onClick={() => openModal()}>{ctaTitle[index]}</button> : ''
            }
            {
              tags && tags[index] && tags[index].length > 0 ?
                <div className='flow-root mt-6'>
                  {
                    tags[index].map((tag, tagIndex) =>
                      <span className={`inline-flex px-4 py-2 bg-white text-puffco-grey-3 rounded-full capitalize float-left ${tags[index].length - 1 === tagIndex ? '' : 'mr-2'} mb-2 font-mono text-[0.75rem] leading-3`} key={`${step}-tag-${tagIndex}`}>{tag}</span>
                    )
                  }
                </div>
                : null
            }
          </div>
        ))}
        {!Array.isArray(displayTitle) && (
          <div className={`pb-6 mb-2 mt-1 lg:pt-[50px] ${productOption && productOption.value_props_title ? 'border-b border-black' : ''}`}>
            <h2 className='mb-3 lg:mb-6 text-base lg:text-20 font-semibold text-puffco-light-black-3'>{displayTitle}</h2>
            {
              description ? <div className='text-xs mb-3 lg:w-[90%]'>{description}</div> : null
            }
            {
              ctaTitle ?
                <button className={`text-xs text-black inline-flex items-center justify-between after:content-[''] after:w-1.5 after:h-1.5 after:border-black after:border-l-2 after:border-t-2 after:inline-block after:ml-2 after:transform after:rotate-[135deg] hover:underline`} onClick={() => openModal()}>{ctaTitle}</button> : ''
            }
            {
              tags && tags.length > 0 ?
                <div className='flow-root mt-6'>
                  {
                    tags.map((tag, index) =>
                      <span className={`inline-flex px-4 py-2 bg-white text-puffco-grey-3 rounded-full capitalize float-left ${tags.length - 1 === index ? '' : 'mr-2'} mb-2 font-mono text-[0.75rem] leading-3`} key={`${step}-tag-${index}`}>{tag}</span>
                    )
                  }
                </div>
                : null
            }
          </div>
        )}
        {
          productOption && productOption.value_props_title && <div className='mb-3 font-bold text-xs'>{productOption.value_props_title}</div>
        }
        {
          productOption && productOption.value_prop_images &&
          <div className='flex flex-wrap gap-1 justify-between text-center'>
            {
              productOption.value_prop_images.map((image, index) =>
                <div className='w-[4.6875rem]' key={`value-prop-image-${index}`}>
                  <div className='h-[4.6875rem] w-full relative overflow-hideen'>
                    <img className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full object-contain' src={image.url} alt={image.alt} />
                  </div>
                  {image.alt && <span className='font-mono mt-2 text-xs text-puffco-light-black-3 leading-6 text-center inline-flex items-center'>{image.alt}</span>}
                </div>
              )
            }
          </div>
        }
      </div>

      <div className='max-h-[300px] overflow-y-auto'>
        <div className='flex items-center justify-between border-b border-black pb-2'>
          <span className='font-bold text-sm tracking-[2px]'>Build</span>
          <span className='font-mono text-base lg:text-20 text-puffco-light-black-3'>
            {step === 1 ? (
              <span className='font-mono text-base lg:text-20 text-puffco-light-black-3'>
                ${parseFloat(basePrice).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.00', '')}
              </span>
            ) : (
              step === 2 ? (
                <span className='font-mono text-base lg:text-20 text-puffco-light-black-3'>
                  ${parseFloat(basePrice + secondStepPrice).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.00', '')}
                </span>
              ) : (
                <span className='font-mono text-base lg:text-20 text-puffco-light-black-3'>
                  ${parseFloat( total).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace('.00', '')}
                </span>
              )
            )}



          </span>
        </div>
        {
          data.metafields.color[color] &&
          <div className='flex items-center justify-between border-b border-black py-2'>
            <span className='font-bold inline-flex items-center text-xs'>
              {data.metafields.color[color].option_image && <img className='w-10 mr-1' src={data.metafields.color[color].option_image} />}
              {data.metafields.color[color].display_name}
            </span>
            {

              (<span className='font-mono text-[0.75rem] leading-6 text-black'>${parseFloat(data.metafields.color[color].list_price).toLocaleString(undefined, { maximumFractionDigits: 2 })}</span>
              )
            }

          </div>
        }
        {
          step > 1 && data.metafields.material[material] &&
          <div className='flex items-center justify-between border-b border-black py-2'>
            <span className='font-bold inline-flex items-center text-xs'>
              {data.metafields.material[material].option_image && <img className='w-10 mr-1' src={data.metafields.material[material].option_image} />}
              {data.metafields.material[material].display_name}
            </span>
            <span className='font-mono text-[0.75rem] material leading-6 text-black'>${parseFloat(data.metafields.material[material].list_price).toLocaleString(undefined, { maximumFractionDigits: 2 })}</span>
          </div>
        }
        {
          step > 1 && data.metafields.material[material].display_name.toLowerCase().includes('proxy') &&
          <div className='flex items-center justify-between border-b border-black py-2'>
            <span className='font-bold inline-flex items-center text-xs'>
              <img className='w-10 mr-1' src={data.free_case_image} alt='Free Case' width='40' height='40' loading='lazy' />
              Free Case
            </span>
            <span className='font-mono text-[0.75rem] leading-6 text-black'>$0</span>
          </div>
        }
        {
          (step === 3 || step === 4) && addons.length > 0 &&
          addons.map((addon, index) => addonLineItem(3, addon, index))
        }
        {
          step === 4 && addons.length > 0 &&
          addons.map((addon, index) => addonLineItem(4, addon, index))
        }
      </div>
      <div className='hidden' id="byoModalContent">{modalHtml()}</div>
    </div>
  )
}

export default Details

